<p-floatlabel variant="on">
    <input pInputText id="widget-name" [value]="name()" (change)="setWidgetName(($any($event)).target.value)"/>
    <label for="widget-name">Название виджета</label>
</p-floatlabel>

<p-divider/>

@if (temporalCount() !== undefined) {
    <!--suppress XmlInvalidId -->
    <label for="element-temporal-count-days" class="element-temporal-count">Временной диапазон</label>
    <p-inputgroup>
        <p-inputNumber inputId="element-temporal-count-days"
                       [ngModel]="temporalCountModel().days"
                       (ngModelChange)="updateTemporalCountModelDays($event)"
                       [disabled]="datasetType() !== undefined && datasetType()?.value === datasetTypes.CURRENT_VALUE"
                       suffix=" д"
                       [min]="0"
                       [max]="maxDays"
                       [showButtons]="true"/>
        <p-inputNumber [ngModel]="temporalCountModel().hours"
                       (ngModelChange)="updateTemporalCountModelHours($event)"
                       [disabled]="datasetType() !== undefined && datasetType()?.value === datasetTypes.CURRENT_VALUE"
                       suffix=" ч"
                       [min]="0"
                       [max]="maxHours"
                       [showButtons]="true"/>
<!--        <p-inputgroup-addon>-->
<!--            <p-button icon="pi pi-check"-->
<!--                      severity="secondary"-->
<!--                      variant="text"-->
<!--                      (click)="setElementTemporalCount(temporalCountModel().toMillis())"-->
<!--                      [disabled]="datasetType() !== undefined && datasetType()?.value === datasetTypes.CURRENT_VALUE"/>-->
<!--        </p-inputgroup-addon>-->
    </p-inputgroup>
}

@if (precision() !== undefined) {
    <p-inputgroup>
        <p-floatlabel variant="on">
            <p-inputNumber inputId="element-precision"
                           [(ngModel)]="precisionModel"
                           [showButtons]="true"
                           [min]="precisionMin"
                           [max]="precisionMax"/>
            <!--suppress XmlInvalidId -->
            <label for="element-precision">Количество точек</label>
        </p-floatlabel>
<!--        <p-inputgroup-addon>-->
<!--            <p-button icon="pi pi-check" severity="secondary" variant="text"-->
<!--                      (click)="setElementPrecision(precisionModel())"/>-->
<!--        </p-inputgroup-addon>-->
    </p-inputgroup>
}

@if (datasetType() !== undefined) {
    <p-inputgroup>
        <p-floatlabel variant="on">
            <p-select inputId="element-dataset-type"
                      [ngModel]="datasetType()"
                      (ngModelChange)="setElementDatasetType($event)"
                      [options]="datasetTypesOptions"
                      optionLabel="name"/>
            <!--suppress XmlInvalidId -->
            <label for="element-dataset-type">Тип данных</label>
        </p-floatlabel>
    </p-inputgroup>
}

@if (threshold() !== undefined) {
    <!--suppress XmlInvalidId -->
    <label for="element-threshold-min" class="element-threshold">Диапазон значений</label>
    <p-inputgroup>
        <p-floatlabel variant="on">
            <p-inputNumber inputId="element-threshold-min"
                           [(ngModel)]="thresholdMinModel"
                           [showButtons]="true"
                           [max]="settingsMin()"
                           [disabled]="settingsLoading()"/>
            <!--suppress XmlInvalidId -->
            <label for="element-threshold-min">От</label>
        </p-floatlabel>
        <p-floatlabel variant="on">
            <p-inputNumber inputId="element-threshold-max"
                           [(ngModel)]="thresholdMaxModel"
                           [showButtons]="true"
                           [min]="settingsMax()"
                           [disabled]="settingsLoading()"/>
            <!--suppress XmlInvalidId -->
            <label for="element-threshold-max">До</label>
        </p-floatlabel>
<!--        <p-inputgroup-addon>-->
<!--            <p-button icon="pi pi-check" severity="secondary" variant="text"-->
<!--                      (click)="setElementThreshold(thresholdMinModel(), thresholdMaxModel())"-->
<!--                      [loading]="settingsLoading()"/>-->
<!--        </p-inputgroup-addon>-->
    </p-inputgroup>
}

<p-divider/>

@if (element() && datasets().length) {
    <div class="datasets">
        <p-button (click)="removeDatasets()"
                  icon="pi pi-trash"
                  styleClass="datasets-remove"
                  severity="danger"
                  outlined
                  [disabled]="!datasetsToRemove().length"/>
        <p-listbox [options]="datasets()" [(ngModel)]="datasetsToRemove" optionLabel="name" multiple/>
    </div>
}
